export default __webpack_public_path__ + "success-cade2d29643afadd49c57ad3c1eaa461.mp3";